import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import SopEmbedPublic from '@/pages/export/sop-embed-public'

const searchSchema = z.object({
  token: z.string().optional(),
  theme: z.enum(['light', 'dark']).optional().default('light'),
})

export const Route = createFileRoute('/export/sop-embed/')({
  validateSearch: searchSchema,
  component: SopEmbedPublic,
})
